import React from 'react';
import { NavLink } from 'react-router-dom';

import ENUMS from '../../enums/index';
import { formatter, enumHelper } from '../../utils';

function FinancialTransactionListItem(props) {
  const showDetails = e => {
    e.preventDefault();
    props.displayDetailsModal(props.id);
  };

  return (
    <tr>
      <td className="text-center">{(props.pageNumber - 1) * props.pageSize + props.index + 1}</td>
      <td className="text-center">
        <NavLink
          to={{
            pathname: '/users/edit',
            userId: props.userId,
            editMode: true,
          }}
        >
          {props.userFullName}
        </NavLink>
      </td>
      <td className="text-center td-number">{props.userMobileNumber}</td>
      <td className="text-center td-number direction-ltr">{props.trackingNumber}</td>
      <td className="text-center">
        {enumHelper.convertEnumValueToTitle(ENUMS.FINANCIAL_TRANSACTION_TYPES.list, props.type)}
      </td>
      <td className="text-center amount td-number">
        <strong className={`text-${props.amount > -1 ? 'success' : 'danger'}`}>
          {`${props.amount > 0 ? '+' : ''}${formatter.numberWithCommas(props.amount)}`}
          <i className={`fas pr-2 fa-arrow-${props.amount > -1 ? 'up' : 'down'}`}></i>
        </strong>
      </td>
      <td className="text-center td-number">{formatter.numberWithCommas(props.remainingCredit)}</td>
      <td className="text-center">{props.createdDate}</td>
      <td className="text-center">{props.createdTime}</td>
      <td title={locales('titles.moreDetails')}>
        <i onClick={showDetails} className="text-center far fa-info-circle pointer"/>
      </td>
    </tr>
  );
}

export default FinancialTransactionListItem;
